import {
  Component,
  HostListener,
  Inject,
  ViewEncapsulation,
} from '@angular/core';
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';
import { AppointmentSelectionSheetComponent } from '@sc/ui-components';
import { ScreenUtils } from '@sc/utils';
import {
  AppointmentValidationInputData,
  AppointmentValidationOutputData,
  AppointmentSheetValidationData,
} from '@sc/data-access-models';

@Component({
  selector: 'sc-appointment-validation-bottom-sheet',
  styleUrls: ['./appointment-validation-bottom-sheet.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [AppointmentSelectionSheetComponent],
  template: `
    <sc-appointment-selection-sheet
      [onlyReplacementVehicle]="data.onlyReplacementVehicle"
      [location]="data.location"
      [appointment]="data.appointment"
      [customer]="data.customer"
      [displayReplacementVehicleSelection]="
        data.displayReplacementVehicleSelection
      "
      [fitter]="data.fitter"
      (cancelEvent)="onCancelAppointment()"
      (validationEvent)="onValidateAppointment($event)"
    ></sc-appointment-selection-sheet>
  `,
})
export class AppointmentValidationBottomSheetComponent {
  onCloseValue: AppointmentValidationOutputData;
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: AppointmentValidationInputData,
    private readonly bottomSheetRef: MatBottomSheetRef<
      AppointmentValidationBottomSheetComponent,
      AppointmentValidationOutputData
    >
  ) {
    this.onCloseValue = {
      type: 'cancel',
    };
  }

  onCancelAppointment() {
    this.onCloseValue = {
      type: 'cancel',
    };

    this.bottomSheetRef.dismiss(this.onCloseValue);
  }

  onValidateAppointment(sheetValidationData: AppointmentSheetValidationData) {
    this.onCloseValue = {
      type: 'success',
      data: sheetValidationData,
    };

    this.bottomSheetRef.dismiss(this.onCloseValue);
  }

  @HostListener('window:resize', ['$event'])
  closeOnResize() {
    if (!ScreenUtils.isMobileResolution()) {
      this.onCancelAppointment();
    }
  }
}
